module.exports = __webpack_public_path__ + "static/img/bg2.6167595.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/6/bg2.png
// module id = PCle
// module chunks = 0